module.exports = __webpack_public_path__ + "img/临颍县.45030c62.png";